import { Toaster as Sonner } from 'sonner';

/** Toasts styled like little cassette labels. Use `toast()` from 'sonner' anywhere. */
export function Toaster() {
  return (
    <Sonner
      position="top-center"
      theme="dark"
      closeButton
      duration={3500}
      toastOptions={{
        classNames: {
          // Errors get a red rim; a variant so it wins over the plain border colour.
          toast:
            '!bg-paper !rounded-lg !border-2 !border-paper-ink/20 !font-sans !text-paper-ink !shadow-card data-[type=error]:!border-danger',
          title: '!font-semibold',
          description: '!text-paper-ink-muted',
          actionButton: '!bg-orange !text-bg',
          cancelButton: '!bg-transparent !text-paper-ink',
          closeButton: '!bg-paper !text-paper-ink !border-paper-ink/20',
          error: '[&_[data-icon]]:!text-danger',
        },
      }}
    />
  );
}
